(() => {
  if (window.__nyumMobileMenuControllerBound) return;
  window.__nyumMobileMenuControllerBound = true;

  const toggleSelector = '[data-nyum-menu-toggle]';
  const menuSelector = '[data-nyum-mobile-menu]';

  const getToggle = () => document.querySelector(toggleSelector);
  const getMenu = toggle => {
    const id = toggle?.getAttribute('aria-controls');
    return (id && document.getElementById(id)) || document.querySelector(menuSelector);
  };

  const setOpen = (open, toggle = getToggle()) => {
    const menu = getMenu(toggle);
    if (!toggle || !menu) return false;

    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('nyum-mobile-menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    return true;
  };

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const toggle = target?.closest(toggleSelector);

    if (toggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(toggle.getAttribute('aria-expanded') !== 'true', toggle);
      return;
    }

    if (target?.closest(`${menuSelector} a`)) setOpen(false);
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') setOpen(false);
  });

  document.addEventListener('shopify:section:load', () => setOpen(false));
  window.addEventListener('pageshow', () => setOpen(false));
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1050) setOpen(false);
  }, { passive: true });
})();
